import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ConfirmContractModal } from '../../../../common/modals';
import {
  confirmContractRequest,
  resendSmsCodeContractRequest,
  selectAccountId,
} from '../../../../features/auth/ducks';
import { apiCallIds } from '../../../../features/auth/api';
import { connectModal } from '../../../../features/modal/hoc';

const mapStateToProps = state => ({
  accountId: selectAccountId(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      confirmContract: confirmContractRequest,
      resendSmsCodeContract: resendSmsCodeContractRequest,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
@connectModal(apiCallIds.CONFIRM_CONTRACT)
export default class ConfirmContract extends Component {
  static propTypes = {
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    accountId: PropTypes.string.isRequired,
    confirmBy: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
  };

  handleSubmit = token => {
    const { actions, accountId, confirmBy } = this.props;
    actions.confirmContract({ accountId, token, confirmBy });
  };

  handleResendSmsCode = callbacks => {
    const { actions, accountId } = this.props;
    actions.resendSmsCodeContract({ accountId, ...(callbacks || {}) });
  };

  render() {
    const { isVisible, isLoading, modalActions, children, confirmBy, accountId } = this.props;

    return (
      <span>
        {cloneElement(children, { onClick: modalActions.show })}
        {isVisible && (
          <ConfirmContractModal
            hideModal={modalActions.hide}
            confirmBy={confirmBy}
            isLoading={isLoading}
            onResendSmsCode={this.handleResendSmsCode}
            resendCooldownKey={`contract:${accountId}:${confirmBy}`}
            onSubmit={this.handleSubmit}
          />
        )}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/dashboard/components/registration-action-alert/ConfirmContract.js